// src/pages/legal/LegalNoticePage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LegalNoticePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white/80 pb-24">
      {/* Header */}
      <div className="sticky top-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10 px-4 py-4 flex items-center">
        <button
          onClick={() => navigate(-1)}
          className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/5 transition-colors"
        >
          <i className="ri-arrow-left-line text-xl"></i>
        </button>
        <h1 className="text-lg font-bold ml-2 tracking-widest text-cyan-400 drop-shadow-[0_0_8px_rgba(34,211,238,0.5)]">
          特定商取引法に基づく表記
        </h1>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-8 space-y-8 text-sm leading-relaxed">
        
        {/* 前文 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <p>
            本ページは、特定商取引法第11条に基づき、Dig-Dim（ディグディム）における通信販売に関する重要事項を表示するものです。
          </p>
          <p className="mt-3 text-white/60 text-xs border-t border-white/10 pt-3">
            本表記の最新版は、常に本ページ（本サービス内の特定商取引法に基づく表記ページ）に掲載されます。本サービスをご利用になる前に、本ページをご確認いただき、最新の内容をご確認ください。
          </p>
        </section>

        {/* プラットフォームの性質 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">プラットフォームの性質</h2>
          <div className="space-y-4">
            <p>Dig-Dimは、CtoCプラットフォーム（消費者間取引の場）です。</p>
            <p>本プラットフォームで販売される商品・サービス（イベントチケット、グッズ等）の販売者は、各商品の出品者（Maker/Node）となります。運営（当社）は、取引の場を提供し、決済代行サービスを通じて安全な取引をサポートしますが、売買契約の当事者にはなりません。</p>
            <p className="text-pink-300 font-bold border border-pink-500/30 p-2 rounded bg-pink-500/10">
              各出品者の詳細情報（事業者名、所在地、連絡先等）は、リクエストに応じて遅滞なく開示いたします。お問い合わせフォームよりご連絡ください。
            </p>
          </div>
        </section>

        {/* 運営事業者情報 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">運営事業者情報</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4">
            <div className="text-white/50 font-bold">販売業者</div>
            <div className="md:col-span-2">
              株式会社Dig-Dim<br/>
              <span className="text-pink-400 text-xs">※登記された正式な法人名、または個人事業主の氏名をご記載ください</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4 mt-4">
            <div className="text-white/50 font-bold">代表責任者</div>
            <div className="md:col-span-2">
              山田 太郎<br/>
              <span className="text-pink-400 text-xs">※戸籍上の本名をご記載ください</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4 mt-4">
            <div className="text-white/50 font-bold">所在地</div>
            <div className="md:col-span-2">
              〒630-8000 奈良県奈良市〇〇町1-2-3<br/>
              <span className="text-pink-400 text-xs">※省略せず最後までご記載ください（バーチャルオフィス等も可）</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4 mt-4">
            <div className="text-white/50 font-bold">お問い合わせ</div>
            <div className="md:col-span-2">
              support@dig-dim.app<br/>
              またはお問い合わせフォームよりご連絡ください。
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4 mt-4">
            <div className="text-white/50 font-bold">電話番号</div>
            <div className="md:col-span-2">
              050-XXXX-XXXX<br/>
              <span className="text-pink-400 text-xs">※Stripe審査のため必ずご記載ください</span><br/>
              <span className="text-white/50 text-xs mt-1 block">※お電話でのお問い合わせは受け付けておりません。ご対応履歴を残すため、必ずメールまたはお問い合わせフォームよりご連絡をお願いいたします。</span>
            </div>
          </div>
        </section>

        {/* 販売価格・料金 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">販売価格・料金</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4">
            <div className="text-white/50 font-bold">販売価格</div>
            <div className="md:col-span-2">
              各商品ページに表示された価格（税込）<br/>
              <span className="text-white/50 text-xs">※表示価格はすべて日本円（JPY）、消費税込みの金額です。</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4 mt-4">
            <div className="text-white/50 font-bold">プラットフォーム利用料等</div>
            <div className="md:col-span-2">
              <ul className="list-disc pl-5 space-y-1">
                <li>イベントチケット：販売価格の10%（販売者負担）</li>
                <li>グッズ販売：販売価格の15%（販売者負担）</li>
                <li>Resonance（投げ銭）：金額の5%（送信者負担）</li>
                <li>サブスクリプション（Maker向け）：月額 300円 / 1,500円（税込）</li>
                <li>サブスクリプション（Node向け）：月額 3,000円（税込）</li>
              </ul>
              <span className="text-white/50 text-xs mt-2 block">※購入者が支払うチケット・グッズ代金には、プラットフォーム利用料が含まれています。</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4 mt-4">
            <div className="text-white/50 font-bold">商品代金以外の必要料金</div>
            <div className="md:col-span-2 space-y-2">
              <div>
                <strong>送料</strong><br/>
                物品の配送が必要な場合、各商品ページまたは購入手続き時に表示されます。
              </div>
              <div>
                <strong>決済手数料</strong><br/>
                クレジットカード決済等の手数料は、原則として販売価格に含まれます。
              </div>
              <div>
                <strong>通信費</strong><br/>
                インターネット接続に必要な通信費はお客様のご負担となります。
              </div>
            </div>
          </div>
        </section>

        {/* 支払方法・時期 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">支払方法・時期</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4">
            <div className="text-white/50 font-bold">支払方法</div>
            <div className="md:col-span-2">
              クレジットカード決済（Visa、Mastercard、American Express、JCB等）<br/>
              デビットカード<br/>
              その他、決済代行サービス（Stripe）を通じた各種決済手段<br/>
              <span className="text-white/50 text-xs">※ご利用可能な決済手段は、商品やサービスによって異なる場合があります。</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4 mt-4">
            <div className="text-white/50 font-bold">支払時期</div>
            <div className="md:col-span-2">
              購入手続き完了時に即時決済されます。<br/>
              <span className="text-white/50 text-xs">※クレジットカードの場合、実際の引き落とし日はカード会社の規約に従います。</span><br/>
              <span className="text-white/50 text-xs">※サブスクリプションは、初回決済日を起算日として毎月自動的に決済されます。</span>
            </div>
          </div>

          {/* ★ チャージバック防止のための販売主体明確化（メール・モーダルと統一） */}
          <div className="mt-6 border border-pink-500/60 rounded-lg bg-pink-500/10 p-5 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-1 h-full bg-pink-500"></div>
            <div className="flex items-start gap-3 pl-2">
              <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-error-warning-fill text-pink-400 text-lg"></i>
              </div>
              <div className="space-y-3 w-full">
                <p className="text-pink-300 font-bold text-sm">
                  【重要】決済明細・領収書に記載される販売者名義について
                </p>
                <p className="text-white/80 text-sm leading-relaxed">
                  クレジットカードの利用明細や領収書に記載される<strong className="text-white">商品代金の販売者名義は、本サービスのシステムを利用する各Maker（アーティスト）またはNode（店舗・会場）となります</strong>。
                </p>
                <p className="text-white/80 text-sm leading-relaxed">
                  Dig-Dim運営（当社）は、決済処理の代行者として取引を仲介しますが、<strong className="text-white">売買契約の当事者はあくまで購入者と各販売者（Maker/Node）</strong>であり、当社は販売主体ではありません。
                </p>

                {/* 購入完了メール・モーダルと同一の注意書き */}
                <div className="bg-black/30 border border-pink-500/30 rounded p-3 space-y-2">
                  <p className="text-pink-200 text-xs font-bold">■ ご購入時の確認事項（購入完了メール・購入確認画面にも同様に表示されます）</p>
                  <ul className="text-white/70 text-xs leading-relaxed space-y-1 list-disc pl-4">
                    <li>本チケット・商品の<strong className="text-white">販売者は各Maker/Node（主催者・出品者）</strong>です。Dig-Dim運営は決済代行者です。</li>
                    <li>カードの利用明細に「<strong className="text-white">Dig-Dim</strong>」と表示される場合がありますが、これは決済代行サービスの仕様によるものです。</li>
                    <li>購入された商品・サービスに関するお問い合わせは、各販売者または当社サポート窓口までご連絡ください。</li>
                    <li className="text-pink-300 font-bold">カード会社へのチャージバック申請を行う前に、必ず当社お問い合わせフォームよりご連絡いただきますようお願いいたします。</li>
                  </ul>
                </div>

                <p className="text-white/50 text-xs leading-relaxed border-t border-pink-500/20 pt-2">
                  ※ 各出品者の詳細情報（事業者名、所在地、連絡先等）は、リクエストに応じて遅滞なく開示いたします。お問い合わせフォームよりご連絡ください。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 商品の引渡時期 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">商品の引渡時期</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4">
            <div className="text-white/50 font-bold">デジタルコンテンツ・チケット・サブスクリプション</div>
            <div className="md:col-span-2">決済完了後、即時にマイページ等で閲覧・利用可能となります。</div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-white/10 pt-4 mt-4">
            <div className="text-white/50 font-bold">物品（グッズ等）</div>
            <div className="md:col-span-2">
              決済完了後、販売者が発送準備を行い、通常3〜7営業日以内に発送されます。<br/>
              <span className="text-white/50 text-xs">※具体的な発送時期は各商品ページまたは販売者のショップポリシーをご確認ください。</span><br/>
              <span className="text-white/50 text-xs">※ハンドメイド品等、受注生産の場合は別途記載された納期が適用されます。</span>
            </div>
          </div>
        </section>

        {/* 返品・交換・キャンセル等 */}
        <section className="bg-white/5 border border-pink-500/30 p-6 rounded-lg relative overflow-hidden">
          <div className="absolute top-0 left-0 w-1 h-full bg-pink-500"></div>
          <h2 className="text-pink-400 font-bold text-lg mb-4 flex items-center gap-2">
            <i className="ri-error-warning-line"></i>返品・交換・キャンセル等
          </h2>
          <p className="mb-6 text-pink-300 font-bold text-sm border border-pink-500/30 p-3 rounded bg-pink-500/10">
            重要なお知らせ：本プラットフォームで取り扱う商品・サービスは、その性質上、原則としてお客様都合による返品・交換・キャンセルはお受けいたしかねます。ご購入前に商品内容・イベント詳細・販売者のショップポリシーを十分にご確認ください。
          </p>

          {/* ★ メール・モーダルと同一のキャンセルポリシー告知ボックス */}
          <div className="mb-8 border border-pink-500/60 rounded-lg bg-pink-500/10 p-5 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-1 h-full bg-pink-500"></div>
            <div className="flex items-start gap-3 pl-2">
              <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-shield-check-fill text-pink-400 text-lg"></i>
              </div>
              <div className="space-y-3 w-full">
                <p className="text-pink-300 font-bold text-sm">
                  🛡️ キャンセル・返金に関する重要事項（購入完了メール・購入確認画面にも同様に表示されます）
                </p>
                <div className="bg-black/30 border border-pink-500/30 rounded p-3 space-y-2">
                  <ul className="text-white/80 text-xs leading-relaxed space-y-2 list-disc pl-4">
                    <li>
                      本チケット・商品の<strong className="text-white">販売者は各Maker/Node（主催者・出品者）</strong>です。Dig-Dim運営は決済代行者であり、売買契約の当事者ではありません。
                    </li>
                    <li>
                      クレジットカードの明細に「<strong className="text-white">Dig-Dim</strong>」と表示される場合がありますが、これはDig-Dimが決済処理を代行しているためです。<strong className="text-white">実際の販売者は各Maker/Node</strong>となります。
                    </li>
                    <li>
                      購入された商品・サービスに関するお問い合わせは、各販売者または当社サポート窓口（support@dig-dim.app）までご連絡ください。
                    </li>
                    <li className="text-pink-300 font-bold">
                      カード会社へのチャージバック申請を行う前に、必ず当社お問い合わせフォームよりご連絡いただきますようお願いいたします。
                    </li>
                  </ul>
                </div>
                <p className="text-white/40 text-xs border-t border-pink-500/20 pt-2">
                  ※ 各出品者の詳細情報（事業者名、所在地、連絡先等）は、リクエストに応じて遅滞なく開示いたします。お問い合わせフォームよりご連絡ください。
                </p>
              </div>
            </div>
          </div>

          <h3 className="text-cyan-300 font-bold mb-2">■ イベントチケットについて</h3>
          <div className="space-y-3 mb-6">
            <div>
              <strong className="text-white">お客様都合によるキャンセル</strong><br/>
              決済完了後のお客様都合（間違えて購入した、予定が変わった、行けなくなった等）によるキャンセル・返金は一切お受けいたしかねます。
            </div>
            <div>
              <strong className="text-white">主催者都合によるイベント中止</strong><br/>
              主催者（NODE/MAKER）都合によるイベント中止の場合に限り、所定の方法で返金対応を行います。<br/>
              <span className="text-white/50 text-xs">※返金方法や時期については、イベント主催者または運営事務局よりご案内いたします。</span><br/>
              <span className="text-white/50 text-xs">※天災・不可抗力等によるイベント中止の場合の返金可否は、主催者の判断に委ねられます。</span>
            </div>
          </div>

          <h3 className="text-cyan-300 font-bold mb-2 border-t border-white/10 pt-4 mt-6">■ グッズ（物品）について</h3>
          <div className="space-y-3 mb-6">
            <div>
              <strong className="text-white">お客様都合による返品</strong><br/>
              お客様都合（イメージと違う、注文間違い、使用済み、開封済み等）による返品・交換・キャンセルは一切お受けいたしかねます。
            </div>
            <div>
              <strong className="text-white">返品・交換を承る場合</strong><br/>
              以下の場合に限り、返品・交換または返金を承ります：
              <ul className="list-disc pl-5 mt-1 space-y-1">
                <li>お届けした商品に破損・汚損等の初期不良があった場合</li>
                <li>ご注文と異なる商品が届いた場合（契約不適合）</li>
              </ul>
            </div>
            <div>
              <strong className="text-white">返品・交換の手順</strong><br/>
              上記に該当する場合は、商品到着後7日以内に、お問い合わせフォームよりご連絡ください。販売者を通じて確認の上、交換または返金の対応をさせていただきます。
            </div>
            <div>
              <strong className="text-white">ショップポリシーについて</strong><br/>
              ハンドメイド品など、販売者が個別の販売ページ等で独自の基準（ショップポリシー）を定めている場合は、そちらの基準が優先して適用されます。各商品ページまたは販売者のプロフィールページをご確認ください。
            </div>
            <div>
              <strong className="text-white">返品時の送料負担</strong><br/>
              初期不良・契約不適合による返品：返送料は販売者負担<br/>
              お客様都合による返品（受付可能な場合）：返送料はお客様負担
            </div>
          </div>

          <h3 className="text-cyan-300 font-bold mb-2 border-t border-white/10 pt-4 mt-6">■ サブスクリプション（月額継続課金）の解約について</h3>
          <div className="space-y-3 mb-6">
            <div>
              <ul className="list-disc pl-5 space-y-1 text-white/90">
                <li>各サブスクリプションプランは、マイページの「設定（Settings）」または「サブスクリプション管理」画面からいつでも解約手続きが可能です。</li>
                <li>解約手続きをされた場合、次回更新日（請求日）の前日までサービスをご利用いただけます。</li>
                <li>月の途中で解約された場合でも、日割り計算による減額や返金は一切行っておりません。</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 出品者情報の開示 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">出品者情報の開示</h2>
          <div className="space-y-4">
            <p>各商品の販売者（Maker/Node）の詳細情報（事業者名、所在地、連絡先等）は、購入者からのリクエストに応じて遅滞なく開示いたします。</p>
            <p>開示をご希望の場合は、お問い合わせフォームより、対象商品の注文番号を添えてご連絡ください。<br/>
            個人情報保護の観点から、開示は購入者本人に限定させていただきます。</p>
          </div>
        </section>

        {/* 動作環境 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">動作環境</h2>
          <p className="mb-2">本サービスを快適にご利用いただくための推奨環境：</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <strong className="text-white">PC（デスクトップ・ノート）</strong>
              <ul className="list-disc pl-5 mt-1 space-y-1 text-white/70">
                <li>Chrome（最新版）</li>
                <li>Firefox（最新版）</li>
                <li>Safari（最新版）</li>
                <li>Edge（最新版）</li>
              </ul>
            </div>
            <div>
              <strong className="text-white">スマートフォン・タブレット</strong>
              <ul className="list-disc pl-5 mt-1 space-y-1 text-white/70">
                <li>iOS 14以降（Safari）</li>
                <li>Android 10以降（Chrome）</li>
              </ul>
            </div>
          </div>
          <p className="mt-4 text-white/50 text-xs">
            安定したインターネット接続環境が必要です。<br/>
            ※推奨環境以外でのご利用の場合、正常に動作しない可能性があります。
          </p>
        </section>

        {/* その他 */}
        <section className="bg-white/5 border border-white/10 p-6 rounded-lg">
          <h2 className="text-cyan-400 font-bold text-lg mb-4">その他</h2>
          <div className="space-y-4">
            <p>本表記に記載のない事項については、利用規約およびプライバシーポリシーに従うものとします。</p>
            <p>本表記の内容は、法令の改正やサービス内容の変更等により変更される場合があります。重要な変更を行う場合は、効力発生日の14日前までに、登録メールアドレスへの通知またはサービス内バナー表示のいずれかの方法でお知らせします。<strong className="text-white">最新の表記は常に本ページに掲載されます。</strong></p>
          </div>
        </section>

        {/* 作成日 */}
        <div className="text-right text-white/40 text-xs pb-4">
          制定日：2025年7月1日　／　最終更新日：2025年7月9日
        </div>

      </div>
    </div>
  );
}